import { useTranslation } from "react-i18next";
import LegalContent from "./LegalContent";
import SEO from "../app/SEO";

export default function SPPrivacyPolicy() {
    const { t } = useTranslation("legal");
    const sections: any[] = t("policies.spPrivacy.sections", { returnObjects: true });

    return (
        <>
            <SEO title={{ title: t("policies.spPrivacy.fullTitle"), pageTitle: t("policies.spPrivacy.fullTitle") }} canonicalPath="/legal/appprivacy" />
            <LegalContent
                title={t("policies.spPrivacy.title")}
                subtitle={t("policies.spPrivacy.subtitle")}
                updated={t("lblUpdated", { date: t("policies.spPrivacy.updated") })}
                sections={sections} />
        </>
    );
}